import { CARD_TYPE } from '../constants/constants'

export const getPoolCardType = ({ cardTypes } = {}) =>
  cardTypes?.filter(cardType => cardType.cardTypeId === CARD_TYPE.POOL_CARD.id)[0]
